import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid gap-4" }
const _hoisted_2 = { class: "grid gap-2" }
const _hoisted_3 = { class: "grid gap-2" }
const _hoisted_4 = { class: "grid gap-2" }

import { Button } from '@/components/ui/button';
    import { computed } from 'vue';
    import { Head, useForm } from '@inertiajs/vue3';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import { useI18n } from 'vue-i18n';
    import AuthLayout from '@/layouts/AuthLayout.vue';
    import InputError from '@/components/InputError.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  props: {
    token: {},
    email: {},
    newUser: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const form = useForm({
        token: props.token,
        email: props.email,
        password: '',
        password_confirmation: '',
    });

    const submit = () => {
        form.post(route('password.store'), {
            onFinish: () => {
                form.reset('password', 'password_confirmation');
            },
        });
    };

    const title = computed(() => {
        return props.newUser ? t('headers.confirm-user') : t('auth.password_reset_title');
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthLayout, {
    title: title.value,
    description: _unref(t)('auth.password_reset_description')
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Head), { title: title.value }, null, 8, ["title"]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Label), { for: "email" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('auth.password_reset_email')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Input), {
              id: "email",
              type: "email",
              name: "email",
              autocomplete: "email",
              modelValue: _unref(form).email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).email) = $event)),
              class: "mt-1 block w-full",
              readonly: ""
            }, null, 8, ["modelValue"]),
            _createVNode(InputError, {
              message: _unref(form).errors.email,
              class: "mt-2"
            }, null, 8, ["message"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Input), {
              id: "password",
              type: "password",
              name: "password",
              autocomplete: "new-password",
              modelValue: _unref(form).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
              class: "placeholder:text-foreground/80",
              autofocus: "",
              placeholder: _unref(t)('auth.password_reset_password')
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(InputError, {
              message: _unref(form).errors.password
            }, null, 8, ["message"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Input), {
              id: "password_confirmation",
              type: "password",
              name: "password_confirmation",
              autocomplete: "new-password",
              modelValue: _unref(form).password_confirmation,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).password_confirmation) = $event)),
              class: "placeholder:text-foreground/80",
              placeholder: _unref(t)('auth.password_reset_confirm_password')
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(InputError, {
              message: _unref(form).errors.password_confirmation
            }, null, 8, ["message"])
          ]),
          _createVNode(_unref(Button), {
            width: "full",
            disabled: _unref(form).processing,
            loading: _unref(form).processing
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.newUser ? _unref(t)('auth.create_user') : _unref(t)('auth.password_reset_send')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["title", "description"]))
}
}

})